import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';
import { setup } from './base/functions';
import setupVue from './base/vue';

$(() => {
    setup();
    setupVue();
});
